var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBankBold(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7570_15185)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99669 5.83317H10.0042M3.33335 8.33317V15.4165M6.66669 8.33317V15.4165M13.3334 8.33317V15.4165M16.6667 8.33317V15.4165M1.66669 7.1415C1.66669 6.144 2.06835 5.53317 2.90002 5.06984L6.32502 3.164C8.11919 2.1665 9.01669 1.6665 10 1.6665C10.9834 1.6665 11.8809 2.1665 13.675 3.164L17.1 5.06984C17.9309 5.53317 18.3334 6.144 18.3334 7.1415C18.3334 7.4115 18.3334 7.54734 18.3042 7.65817C18.1492 8.2415 17.62 8.334 17.1092 8.334H2.89085C2.38002 8.334 1.85169 8.24234 1.69585 7.65817C1.66669 7.5465 1.66669 7.4115 1.66669 7.1415ZM15.8334 15.4165H4.16669C3.50365 15.4165 2.86776 15.6799 2.39892 16.1487C1.93008 16.6176 1.66669 17.2535 1.66669 17.9165C1.66669 18.027 1.71059 18.133 1.78873 18.2111C1.86687 18.2893 1.97285 18.3332 2.08335 18.3332H17.9167C18.0272 18.3332 18.1332 18.2893 18.2113 18.2111C18.2895 18.133 18.3334 18.027 18.3334 17.9165C18.3334 17.2535 18.07 16.6176 17.6011 16.1487C17.1323 15.6799 16.4964 15.4165 15.8334 15.4165Z",
    stroke: "#243C7B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7570_15185"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankBold);
export default __webpack_public_path__ + "static/media/bank-bold.a3037dc1900f46b9486fb5e631cf64c4.svg";
export { ForwardRef as ReactComponent };